// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1BW9x","type":"styles_type__1XyZm","choices":"styles_choices__2NLyc"};